import { createI18n } from "vue-i18n";
import locale from '@/locales/default/en'
import { getStartingLocale } from "@/i18n/get-start-locale";

const messages = {
  ...locale
}

export default createI18n({
  locale: getStartingLocale(),
  fallback: 'en',
  globalInjection: true,
  legacy: false,
  messages
})
